import React from "react";
import { List, Card } from "antd";

const data = [
  {
    title: "Basic",
    content: [
      {
        price: "ugx 30k",
        support: "For 1 month",
        backup: "All features",
        access: "Access from anywhere",
      },
    ],
  },
  {
    title: "Premium",
    content: [
      {
        price: "ugx 100k",
        support: "For 4 month",
        backup: "All features",
        access: "Access from anywhere",
      },
    ],
  },
  {
    title: "Enterprise",
    content: [
      {
        price: "ugx 400k",
        support: "For 1 year",
        backup: "All features",
        access: "Access from anywhere",
      },
    ],
  },
];

function AppPricing() {
  return (
    <div id="pricing" className="block pricingBlock bgGray">
      <div className="container-fluid">
        <div className="titleHolder">
          <h2>Choose a plan to fit your needs</h2>
          {/*Famis */}
          <p>
            Choose a plan that fits your needs and budget. We have plans for all
            budgets.
          </p>
        </div>
        <List
          grid={{
            gutter: 16,
            xs: 1,
            sm: 1,
            md: 3,
            lg: 3,
            xl: 3,
            xxl: 3,
          }}
          dataSource={data}
          renderItem={(item) => (
            <List.Item>
              <Card title={item.title}>
                <p className="large">{item.content[0].price}</p>
                <p>{item.content[0].support}</p>
                <p>{item.content[0].backup}</p>
                <p>{item.content[0].access}</p>
              </Card>
            </List.Item>
          )}
        />
      </div>
    </div>
  );
}

export default AppPricing;
